export const SURVEY_CREATE_INSTANCE_REQUESTED = 'SURVEY_CREATE_INSTANCE_REQUESTED';
export const SURVEY_TRACKED_CREATE_INSTANCE_REQUESTED = 'SURVEY_TRACKED_CREATE_INSTANCE_REQUESTED';
export const SURVEY_CREATE_INSTANCE_SUCCESS = 'SURVEY_CREATE_INSTANCE_SUCCESS';
export const SURVEY_CREATE_INSTANCE_FAILURE = 'SURVEY_CREATE_INSTANCE_FAILURE';

export const SURVEY_REQUESTED = 'SURVEY_REQUESTED';
export const SURVEY_TRACKED_REQUESTED = 'SURVEY_TRACKED_REQUESTED';
export const SURVEY_SUCCESS = 'SURVEY_SUCCESS';
export const SURVEY_FAILURE = 'SURVEY_FAILURE';

export const INSTANCE_REQUESTED = 'INSTANCE_REQUESTED';
export const INSTANCE_SUCCESS = 'INSTANCE_SUCCESS';
export const INSTANCE_FAILURE = 'INSTANCE_FAILURE';

export const INSTANCE_POST_REQUESTED = 'INSTANCE_POST_REQUESTED';
export const INSTANCE_POST_SUCCESS = 'INSTANCE_POST_SUCCESS';
export const INSTANCE_POST_FAILURE = 'INSTANCE_POST_FAILURE';

export const LINK_TYPE_REDIRECT_DELAY = 5000;
